import { render } from "./NavbarBrand.vue?vue&type=template&id=36a0b012"
import script from "./NavbarBrand.vue?vue&type=script&lang=js"
export * from "./NavbarBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__